/* Behaviour for sections/search-drawer.liquid.

   Two jobs. The first is predictive search: as the shopper types, ask the Predictive
   Search API for sections/predictive-search.liquid rendered against the query and paste
   it in. The section is asked for rather than the JSON because the markup a match is
   drawn with — the row, the stepper, the money format — belongs in Liquid, not here.

   The second is the quick-add control on each row: keep the figure at the top right in
   step with the stepper beside it, and post the form without leaving the page.

   assets/drawer.js owns opening and closing. */
(function () {
  'use strict';

  var panel = document.querySelector('[data-drawer="search"]');
  if (!panel) return;

  var input = panel.querySelector('[data-predictive-input]');
  var results = panel.querySelector('[data-predictive-results]');
  var fallback = panel.querySelector('[data-search-default]');
  if (!input || !results) return;

  var MIN_TERMS = 2;
  var DEBOUNCE = 250;

  var timer = null;
  var token = 0;

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function showFallback(show) {
    if (fallback) fallback.hidden = !show;
  }

  function clear() {
    results.innerHTML = '';
    showFallback(true);
    input.setAttribute('aria-expanded', 'false');
  }

  function run(query) {
    /* Every request carries a ticket. Answers can arrive out of order — a short query
       is quicker to serve than the longer one typed after it — and without this the
       slower, staler answer would be the one left on screen. */
    var ticket = ++token;

    var url =
      root() +
      'search/suggest?q=' +
      encodeURIComponent(query) +
      '&section_id=predictive-search' +
      '&resources[type]=product' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (ticket !== token) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-predictive-inner]');

        if (!next) {
          clear();
          return;
        }

        results.innerHTML = '';
        results.appendChild(next);

        /* Matches take the strip's place; a query that found nothing sits above it, so
           the shopper still has somewhere to go. */
        showFallback(next.dataset.hasResults !== 'true');
        input.setAttribute('aria-expanded', 'true');
      })
      .catch(function () {
        if (ticket === token) clear();
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var query = input.value.trim();

    if (query.length < MIN_TERMS) {
      /* Bumping the token cancels any answer still in flight, so a request made before
         the field was cleared cannot land on the empty state a moment later. */
      token++;
      clear();
      return;
    }

    timer = setTimeout(function () {
      run(query);
    }, DEBOUNCE);
  });

  /* Reopening with a query still in the field should show what it found, not the
     bestsellers it was showing when it closed. */
  panel.addEventListener('drawer:open', function () {
    var query = input.value.trim();
    if (query.length >= MIN_TERMS) run(query);
  });

  /* ------------------------------------------------------------------ quick add */

  function money(cents, template) {
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (!template) return '$' + withCommas;

    return template
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas);
  }

  function syncTotal(row) {
    var total = row.querySelector('[data-search-row-total]');
    var field = row.querySelector('[data-quantity-input]');
    if (!total || !field) return;

    var unit = parseInt(total.dataset.unitPrice, 10);
    var quantity = parseInt(field.value, 10);
    if (isNaN(unit) || isNaN(quantity)) return;

    total.textContent = money(unit * quantity, window.themeMoneyFormat);
  }

  /* Delegated from the panel, not bound per row: the rows are replaced on every
     keystroke, and anything bound to them would be thrown away with them. */
  panel.addEventListener('click', function (event) {
    var step = event.target.closest('[data-quantity-step]');
    if (!step) return;

    var row = step.closest('[data-search-row]');
    if (!row) return;

    var selector = step.closest('[data-quantity-selector]');
    var field = selector && selector.querySelector('[data-quantity-input]');
    if (!field) return;

    var min = parseInt(field.min, 10);
    var next = (parseInt(field.value, 10) || 0) + (parseInt(step.dataset.quantityStep, 10) || 0);
    if (!isNaN(min)) next = Math.max(min, next);

    field.value = next;
    syncTotal(row);
  });

  panel.addEventListener('change', function (event) {
    var field = event.target.closest('[data-quantity-input]');
    if (!field) return;

    var row = field.closest('[data-search-row]');
    if (!row) return;

    var min = parseInt(field.min, 10);
    var value = parseInt(field.value, 10);
    if (isNaN(value) || (!isNaN(min) && value < min)) field.value = isNaN(min) ? 1 : min;

    syncTotal(row);
  });

  /* The add itself is left to assets/cart-drawer.js, which already intercepts every
     /cart/add form on the page, posts it and opens the bag. Handling it again here
     would add the row twice. */
})();
